import { createAsyncThunk } from '@reduxjs/toolkit';
import { SUBSCRIPTION_URL } from '@custom/Utils/constants/apiUrls';

const subscribedStudies = createAsyncThunk('subscribedStudies', async (obj:any) => {
  try {
    const token = sessionStorage.getItem('token') || localStorage.getItem('token');
    let url = `${SUBSCRIPTION_URL.getSubscribedStudies}`
    let response = await fetch(url, {
      method: 'POST',
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      body:JSON.stringify(obj)
    })
    return await response.json()
  } catch (error) {
    return error;
  }
});

export default subscribedStudies;
